import React, { useEffect, useState } from 'react'
import { Navigate } from 'react-router-dom'
import { getAuthToken } from '../helper/storage'
import { errorToast } from '../util/Toast/toast'
import { getUserRole, hasAccess } from '../helper/function'

export default function PrivateRoute({ children, permission }) {
  const [isToastShown, setIsToastShown] = useState(false)
  const authToken = getAuthToken()
  const userRole = getUserRole()

  useEffect(() => {
    if (!authToken && !isToastShown) {
      // errorToast('Session Expired!')
      setIsToastShown(true)
    }
  }, [authToken, isToastShown])

  // Check if user has access to the route based on permission
  if (!authToken) {
    return <Navigate to="/login" replace />
  }

  if (permission && !hasAccess(permission, userRole)) {
    errorToast("You don't have permission to access this page.")
    return <Navigate to="/" replace /> // Redirect to a fallback page, e.g., the dashboard
  }

  return <React.Suspense fallback={<>...</>}>{children}</React.Suspense>
}
